import API, { APIResponse } from '../../../lib/commons/api'
import { IItemDelta } from '../../../domain/value-object/ItemDeltaInputVO'
import { UserBasic } from '../../../lib/functions/user'

export type ProgramProjectReportType = 'PROJECT' | 'WORKGROUP' | 'PROCESS'

export type ProgressValueType = 'HOUR' | 'COUNT'

export type ProgramProjectReportProgressDto = {
  total: number | null
  scheduledCompleted: number | null
  completed: number | null
  delayed: number | null
  actualResource: number | null
}

export type ProgramProjectReportProgressValuesDto = {
  count: ProgramProjectReportProgressDto | null
  hour: ProgramProjectReportProgressDto | null
}

export type ProgramProjectReportResourceDto = {
  totalResource: number | null
  investedResource: number | null
  actualResource: number | null
}

export type ProgramProjectReportProfitLossDto = {
  totalBudget: number | null
  scheduledUsedBudget: number | null
  actualUsedBudget: number | null
  totalRevenue: number | null
  scheduledRevenue: number | null
  actualRevenue: number | null
  forecastRevenue: number | null
}

export type ProgramProjectReportDto = {
  uuid: string
  type: ProgramProjectReportType
  code: string | null
  displayName: string | null
  iconUrl: string | null
  status: string | null
  scheduledDate: { startDate: string | null; endDate: string | null } | null
  progress: ProgramProjectReportProgressValuesDto | null
  resource: ProgramProjectReportResourceDto | null
  profitLoss: ProgramProjectReportProfitLossDto | null
  children: ProgramProjectReportDto[]
  revision: string | null
  createdBy: UserBasic | null
  createdAt: number | null
  updatedBy: UserBasic | null
  updatedAt: number | null
}

export const getProgramProjectReport =
  async (): Promise<ProgramProjectReportDto | null> => {
    const response: APIResponse = await API.functional.request(
      'GET',
      '/api/v1/projects/program_project_report',
      undefined
    )
    return (response.json as ProgramProjectReportDto | null) ?? null
  }

type FieldDelta = IItemDelta<number | null>

export type SaveProgressAddEntry = {
  planNodeUuid: string | null
  valueType: ProgressValueType
  total: number | null
  scheduledCompleted: number | null
  completed: number | null
  delayed: number | null
  actualResource: number | null
}

export type SaveProgressEditEntry = {
  planNodeUuid: string | null
  valueType: ProgressValueType
  total?: FieldDelta
  scheduledCompleted?: FieldDelta
  completed?: FieldDelta
  delayed?: FieldDelta
  actualResource?: FieldDelta
}

export type SaveProgressKeyEntry = {
  planNodeUuid: string | null
  valueType: ProgressValueType
}

export type SaveProgramProjectReportRequest = {
  resource?: Partial<Record<keyof ProgramProjectReportResourceDto, FieldDelta>>
  profitLoss?: Partial<
    Record<keyof ProgramProjectReportProfitLossDto, FieldDelta>
  >
  progresses: {
    added: SaveProgressAddEntry[]
    edited: SaveProgressEditEntry[]
    deleted: SaveProgressKeyEntry[]
  }
}

export const saveProgramProjectReport = (
  request: SaveProgramProjectReportRequest
): Promise<APIResponse> =>
  API.functional.request(
    'POST',
    '/api/v1/projects/program_project_report',
    request
  )
